<div ngbDropdown class="d-inline-block">
  <div
    class="background-hover"
    style="
      color: white;
      margin-right: 10px;
      font-weight: 300;
      font-size: 14px;
      padding: 4px 10px;
      border-radius: 2px;
      cursor: pointer;
    "
    id="dropdownBasic1"
    ngbDropdownToggle
  >
    {{ activeLanguage.toUpperCase() }}
  </div>
  <div
    class="background-dropdown"
    ngbDropdownMenu
    aria-labelledby="dropdownBasic1"
  >
    <button
      class="background-dropdown-item"
      style="color: white"
      *ngFor="let language of languages"
      (click)="changeLanguage(language)"
      ngbDropdownItem
    >
      {{ language.language.toUpperCase() }}
    </button>
  </div>
</div>
